"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_use_1 = require("react-use");
const classnames_1 = __importDefault(require("classnames"));
const framer_motion_1 = require("framer-motion");
const PopoverPortal_1 = __importDefault(require("./PopoverPortal"));
const BackDrop_1 = __importDefault(require("./BackDrop"));
const PopoverContext_1 = __importDefault(require("../../contexts/PopoverContext"));
const __1 = require("../..");
const helpers_1 = require("../../lib/helpers");
const usePopperJs_1 = __importDefault(require("../../hooks/Popover/usePopperJs"));
const animations_1 = require("../../lib/config/animations");
const NavContext_1 = __importDefault(require("../../contexts/NavContext"));
const useVirtualKeyboard_1 = require("../../hooks/Popover/useVirtualKeyboard");
const mergeProps_1 = __importDefault(require("../../lib/mergeProps"));
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
const PopoverArrow = __1.createJourneyComponent('j-popover-arrow', 'div');
const Popover = (props) => {
    var _a, _b, _c, _d;
    const { children, onAnimationComplete: onAnimationCompleteFromProps, isOpen, backdrop, shouldClose, mobileView = true, targetRef, closeOnBtnClick = true, onClose } = props;
    const virtualKeyboardVisible = useVirtualKeyboard_1.useVirtualKeyboard(isOpen);
    const popoverRef = react_1.useRef(null);
    const { inNav } = react_1.useContext(NavContext_1.default);
    const { styles, setArrowEle, attributes, setPopperEle, } = usePopperJs_1.default({ targetRef, isOpen });
    react_use_1.useClickAway(popoverRef, (e) => {
        var _a;
        if (shouldClose && !shouldClose(e)) {
            return;
        }
        // we clicked on the button or element we are positioned under.
        if (e.target === (targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) || (e.target && ((_a = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)))) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            return;
        }
        // wait for the useEffect to trigger.
        if (!isOpen)
            return;
        // The timeout prevents this click-away from running before other mouse events which may toggle that same select again.
        onClose && setTimeout(() => onClose(), 0);
    });
    /*
    * Popover from the target kinda doesnt work well on mobile, lets make it pop up at the bottom more like
    * a native select.
    */
    const mobileViewMode = helpers_1.isSmallScreen() && mobileView && !inNav;
    const mobileViewHeader = (_a = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) === null || _a === void 0 ? void 0 : _a.textContent;
    const popperProps = mobileViewMode ? {} : Object.assign({ style: styles.popper }, attributes.popper);
    const contextValue = react_1.useMemo(() => ({
        isOpen,
        targetRef,
        onClose,
        closeOnBtnClick,
        inPopover: true,
    }), [closeOnBtnClick, isOpen, onClose, targetRef]);
    let virtualKeyboardStyle = {};
    if (helpers_1.isClient()) {
        const targetEle = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current;
        const isInput = (typeof (targetEle === null || targetEle === void 0 ? void 0 : targetEle.className) === 'string' && ((_b = targetEle === null || targetEle === void 0 ? void 0 : targetEle.className) === null || _b === void 0 ? void 0 : _b.includes('j-input'))) || targetEle instanceof HTMLInputElement;
        // When our keyboard becomes visible we need to strategically adjust the popover position. */
        if (virtualKeyboardVisible) {
            const targetBounding = (_d = (_c = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) !== null && _d !== void 0 ? _d : { y: 0, height: 0 };
            /* If we are an input it matters that we can see it while popover is displayed, otherwise not really. */
            const minimumTop = isInput ? (targetBounding === null || targetBounding === void 0 ? void 0 : targetBounding.y) + (targetBounding === null || targetBounding === void 0 ? void 0 : targetBounding.height) : 10;
            const screenHeight = document.body.offsetHeight;
            /* Ensure we dont exceed past the keyboard (assumes its roughly half screen) */
            const maxHeight = (screenHeight / 2) - minimumTop;
            virtualKeyboardStyle = {
                top: minimumTop,
                height: maxHeight,
            };
        }
    }
    const forwardedRef = useAddToForwardRef_1.useAddToForwardRef(props, [popoverRef, setPopperEle]);
    let primitiveProps = helpers_1.usePrimitiveProps(props, {
        className: classnames_1.default({ 'mobile-view': mobileViewMode, 'virtual-keyboard': virtualKeyboardVisible }),
        style: __1.useDeepMemo(virtualKeyboardStyle),
    });
    primitiveProps = mergeProps_1.default(primitiveProps, popperProps);
    primitiveProps.ref = forwardedRef;
    return (react_1.default.createElement(PopoverContext_1.default.Provider, { value: contextValue },
        react_1.default.createElement(PopoverPortal_1.default, { selector: "body" },
            react_1.default.createElement(BackDrop_1.default, { isOpen: (backdrop || mobileViewMode) && isOpen, onClick: onClose }),
            react_1.default.createElement(framer_motion_1.AnimatePresence, null, isOpen && (react_1.default.createElement(framer_motion_1.motion.div, Object.assign({}, primitiveProps, animations_1.getAnimationProps(animations_1.PopoverAnim)),
                !mobileViewMode && react_1.default.createElement(PopoverArrow, { "data-popper-arrow": true, ref: setArrowEle, style: styles.arrow }),
                react_1.default.createElement(framer_motion_1.motion.div, Object.assign({ className: "j-popover-content" }, animations_1.getAnimationProps(animations_1.PopoverContentAnim)),
                    mobileViewMode && mobileViewHeader && mobileViewHeader !== '' && (react_1.default.createElement("div", { className: "j-popover-label" }, mobileViewHeader)),
                    children)))))));
};
exports.default = __1.withJourney('j-popover', Popover, { wrapsHref: false });
